import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    InitialCausality,
    InitialCausalityHistorical,
} from '../../../../../shared/types/typifications/initialCausality';
import { INITIAL_CAUSALITY } from '../../../../../routes/paths';
import {
    asyncGetInitialCausality,
    asyncGetInitialCausalityHistorical,
} from '../../../../../services/initial.causality.service';

export const useInitialCausalityDetail = (showHistorical: boolean) => {
    const navigate = useNavigate();
    const { idInitialCausality } = useParams();
    const [loading, setLoading] = useState(false);
    const [initialCausality, setInitialCausality] =
        useState<InitialCausality>();
    const [initialCausalityHistorical, setInitialCausalityHistorical] =
        useState<InitialCausalityHistorical[]>();

    useEffect(() => {
        if (Boolean(idInitialCausality?.trim())) {
            setLoading(true);
            asyncGetInitialCausality(idInitialCausality?.trim())
                .then((initialCausality) => {
                    if (!initialCausality) navigate(INITIAL_CAUSALITY);
                    setInitialCausality(initialCausality);
                })
                .finally(() => setLoading(false));
        }
    }, [idInitialCausality]);

    useEffect(() => {
        if (showHistorical && Boolean(idInitialCausality?.trim())) {
            asyncGetInitialCausalityHistorical(idInitialCausality?.trim())
                .then((resp) => {
                    if (resp) setInitialCausalityHistorical(resp);
                    else navigate(INITIAL_CAUSALITY);
                })
                .finally();
        }
    }, [showHistorical]);

    return { loading, initialCausality, initialCausalityHistorical };
};
